import React from 'react';
import { ChevronIcon } from '../../components/icons';
import { FAQ_ITEMS } from './faq-content.mjs';

export default function Faq() {
  return (
    <ul className="faq">
      {FAQ_ITEMS.map(({ question, answer }) => (
        <li key={question}>
          <details className="faq__item">
            <summary>
              <span>{question}</span>
              <ChevronIcon />
            </summary>
            <p>{answer}</p>
          </details>
        </li>
      ))}
    </ul>
  );
}
